import request from './request'
import md5 from 'js-md5'
const base = 'web'
const common = 'common'
// 司机加盟
export const driverJoin = params => { return request.post(`${base}/operation/officialWebSite/i/driver/join`, params) }
// 商务合作
export const businessCooperation = params => { return request.post(`${base}/operation/officialWebSite/i/business/cooperation`, params) }
// 获取系统参数信息(paramCode 系统参数编码；businessAreaId 经营区域标识 默认0)
export const getSystemParams = params => { return request.get(`${common}/system/sysparam/i/findSysparamByCode/${params.paramCode}/${params.businessAreaId}`) }

// 上传文件
// file(文件名必填) path(路径)
export const uploadFiles = params => { return request.post(`/common/system/file/i/upload`, params) }

// 用户注册
export const userRegister = ({ password, ...res }) => { return request.post(`${base}/user/BBCUser/i/addUser`, { ...res, password: md5(password) }) }
// 用户注册发送验证码
export const registerSendCode = data => { return request.post(`${base}/user/BBCUser/i/addUser/sendCode`, data) }

// 密码登录
export const pwdLogin = ({ password, ...res }) => { return request.post(`${base}/user/BBCUser/i/login/pwd`, { ...res, password: md5(password) }) }
// 手机验证码登录
export const codeLogin = data => { return request.post(`${base}/user/BBCUser/i/login/code`, data) }
// 用户登录发送验证码
export const loginSendCode = data => { return request.post(`${base}/user/BBCUser/i/login/sendCode`, data) }

// 用户修改密码
export const changePwd = ({ password, ...res }) => { return request.post(`${base}/user/BBCUser/i/changePwd`, { ...res, password: md5(password) }) }
// 用户修改密码校验验证码
export const changePwdCheckCode = data => { return request.post(`${base}/user/BBCUser/i/changePwd/checkCode`, data) }
// 用户修改密码发送验证码
export const changePwdSendCode = data => { return request.post(`${base}/user/BBCUser/i/changePwd/sendCode`, data) }

// 用户购买商品生成支付二维码
export const getPayQrCode = data => { return request.post(`${base}/user/BBCUser/getPayQrCode`, data) }

// 基础信息
export const getUserInfo = params => { return request.get(`${base}/user/BBCUser/getUserInfo`, params) }

// 订单记录
export const getOrderPage = params => { return request.get(`${base}/user/BBCUser/getOrderPage?userId=${params.userId}&pageSize=9999&pageNum=1`, params) }

// 用户修改昵称
export const changeName = data => { return request.post(`${base}/user/BBCUser/changeName`, data) }

// 修改密码-校验密码
export const checkPwd = ({ oldPwd }) => { return request.post(`${base}/user/BBCUser/checkPwd`, { oldPwd: md5(oldPwd) }) }

// 修改密码
export const changePwdByPwd = ({ oldPwd, password }) => { return request.post(`${base}/user/BBCUser/changePwdByPwd`, { oldPwd: md5(oldPwd), password: md5(password) }) }

// 修改手机-发送验证码
export const changePhonesendCode = data => { return request.post(`${base}/user/BBCUser/changePhone/sendCode`, data) }

// 修改手机-校验验证码
export const changePhonecheckCode = data => { return request.post(`${base}/user/BBCUser/changePhone/checkCode`, data) }

// 修改手机号
export const changePhone = data => { return request.post(`${base}/user/BBCUser/changePhone`, data) }

// 修改手机号 /web/user/BBCUser/addMch
export const addMch = data => { return request.post(`${base}/user/BBCUser/addMch`, data) }
// 订单记录
export const getUserPayOrderStatus = params => { return request.get(`${base}/user/BBCUser/getUserPayOrderStatus?orderNo=${params.orderNo}`, params) }

// 查询用户可以使用的优惠券列表
export const getCouponList = params => { return request.get(`${base}/user/BBCUser/getCouponList`, params) }

// 查询待支付订单
export const getUnPayQrCode = data => { return request.post(`${base}/user/BBCUser/getUnPayQrCode`, data) }
// 可用优惠券分页查询
export const getCouponPageCan = params => {return request.get(`${base}/user/BBCUser/getCouponPageCan?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, params) }
// 不可用优惠券分页查询
export const getCouponPageCanNot = params => { return request.get(`${base}/user/BBCUser/getCouponPageCanNot?pageSize=${params.pageSize}&pageNum=${params.pageNum}`, params) }